




























import {Component, Vue} from 'vue-property-decorator'

@Component
export default class Analyzing extends Vue {
  maxTimeSec = 10 * 60
  currentTimeSec = this.maxTimeSec
  timer = 0

  getPercentage() {
    const percent = Math.floor(((this.maxTimeSec - this.currentTimeSec) / this.maxTimeSec) * 100)
    return percent === 100 ? '99%' : `${percent}%`
  }

  getWidth() {
    const percent = Math.floor(((this.maxTimeSec - this.currentTimeSec) / this.maxTimeSec) * 100)
    const width = Math.floor((87 - 34) * percent / 100 + 34)
    return width
  }

  getTimeString() {
    if(this.currentTimeSec < 0 && this.timer) {
      clearInterval(this.timer)
      return
    }

    const min = Math.floor(this.currentTimeSec/ 60)
    const sec = this.currentTimeSec % 60
    return `${min}:${sec > 9 ? sec : `0${sec}`}`
  }

  mounted() {
    this.timer = window.setInterval(() => {
      if(this.currentTimeSec <= 0) {
        clearInterval(this.timer)
        return
      }
      this.currentTimeSec -= 1
    }, 1000)
  }

  unmounted() {
    if(this.timer) clearInterval(this.timer)
  }
}
